<template>
  <div class="personal">
    <el-form v-if="spNo">
      <el-form-item :label="$t('message.spNo')">
        <el-input v-model="spNo" disabled></el-input>
      </el-form-item>
    </el-form>
    <GradientBtn
      v-if="
        ![
          'HZMB_FIRST_PERSON',
          'HZMB_FIRST_COMPANY',
          'HZMB_RENEW_PERSON',
          'HZMB_RENEW_COMPANY',
          'HZMB_MO_RENEW_PERSON',
          'HZMB_MO_RENEW_COM',
        ].includes(serviceType)
      "
      class="personal_btn"
      @click="toOnePass"
      :disabled="
        this.$route.params && this.$route.params.businessType === 'BOOKING'
      "
      white
      >{{ $t("message.Verification.personal.onePass_verify") }}</GradientBtn
    >
    <!-- v-if="this.$route.params.serviceType !== 'SCHOOL_RENEW'" -->
    <GradientBtn
      v-if="
        ![
          'HZMB_H_FIRST_PERSON',
          'HZMB_H_RENEW_PERSON',
          'HZMB_H_CANCEL_PERSON',
          'HZMB_H_FIRST_COMP',
          'HZMB_H_RENEW_COMP',
          'HZMB_H_CANCEL_COMP',
        ].includes(serviceType)
      "
      class="personal_btn"
      @click="toPhone"
      >{{ $t("message.Verification.personal.phone_verify") }}</GradientBtn
    >
  </div>
</template>

<script>
import * as BookingApplicationAPI from "@/api/Booking/BookingApplicationAPI";
import GradientBtn from "../../components/GradientBtn";
// import { basePath } from "../../api/axios";
import util from "@/util/util";
const { splicingAccountLogin, splicingEntityLogin } = util;
export default {
  components: { GradientBtn },
  data() {
    return {
      basePath: "",
      business: {}, // 業務信息
      serviceType: "",
      spNo: null,
    };
  },
  methods: {
    toOnePass() {
      localStorage.setItem("personalType", "onePass");
      this.$store.commit("changePersonalType", "onePass");
      const serviceType =
        this.$route.params.serviceType || this.$store.state.serviceType;
      // 由於補交是通過url直接進入的方式，沒有通過Entry頁面，需要在當前頁面設置serviceType
      localStorage.setItem("serviceType", serviceType);

      localStorage.setItem("entryType", "application");
      if (
        [
          "SCHOOL_RENEW",
          "HZMB_H_FIRST_COMP",
          "HZMB_H_CANCEL_COMP",
          "HZMB_CHANGE_COMP",
          "HZMB_GH_CHANGE_COMP",
        ].includes(serviceType)
      ) {
        window.location.href = splicingEntityLogin(serviceType);
      } else {
        window.location.href = splicingAccountLogin(serviceType);
      }
    },
    toPhone() {
      localStorage.setItem("personalType", "phone");
      this.$store.commit("changePersonalType", "phone");
      const params = this.$route.params;
      const serviceType = this.serviceType;
      let path = null;
      if (params.businessType && params.serviceType) {
        path = `/personal-type/phone/${params.businessType}/${params.serviceType}`;
      } else if (
        [
          "HZMB_CHANGE_PERSON",
          "HZMB_CHANGE_COMP",
          "HZMB_GH_CHANGE_COMP",
        ].includes(serviceType)
      ) {
        path = `/verification/hzmb-change-vd/${serviceType}/phone`;
      } else {
        path = "/personal/phone";
      }
      this.$router.push(path);
    },
    // 獲取業務信息
    async getBusiness() {
      const { serviceType } = this.$route.params;
      const businessList = await BookingApplicationAPI.getBusinessList(
        serviceType
      );
      if (!businessList) {
        throw this.$t("message.ErrorMessage.BUSINESS_NOT_FOUND");
      }
      const business =
        businessList.find((item) => item.businessType.code == serviceType) ||
        {};
      this.business = business;
      const { businessType } = business;
      // 設置頁面標題
      if (businessType)
        this.$store.commit("changeServiceTypeConfig", {
          nameEn: businessType.nameEn,
          namePt: businessType.namePt,
          nameSc: businessType.nameSc,
          nameTc: businessType.nameTc,
        });
      return business;
    },
  },
  created() {
    this.serviceType =
      this.$route.params.serviceType || this.$store.state.serviceType;

    let { spNo } = this.$route.query;
    if (spNo) {
      localStorage.setItem("spNo", spNo);
      this.spNo = spNo;
    } else {
      localStorage.removeItem("spNo");
    }

    this.basePath = process.env.VUE_APP_BASE_RESOURCE_PATH;
    if (this.$route.params && this.$route.params.businessType === "BOOKING") {
      this.getBusiness();
    }
  },
};
</script>

<style lang="scss" scoped>
.el-form + .personal_btn {
  margin-top: calc(16px * 4);
}
.personal {
  margin: auto;
  text-align: center;
  height: 300px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.personal_btn {
  margin-bottom: 36px;
  margin-left: auto;
  margin-right: auto;
  width: 430px;
  max-width: 100%;
}
</style>
